import React, { ChangeEvent, useState } from 'react';
import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import { isValidEmailAddress } from 'helpers/index';
import { linkSephoraAccount } from 'actions/sephora';
import useMartyContext from 'hooks/useMartyContext';
import useSephoraContext from 'hooks/useSephoraContext';
import { selectIsLoadingLoyalty } from 'selectors/sephora';
import { SmallLoader } from 'components/Loader';

import css from 'styles/components/sephora/beautyInsiderEmailForm.scss';

const BeautyInsiderEmailForm = () => {
  const { testId } = useMartyContext();
  const [error, setError] = useState('');
  const { sephoraEmail, setSephoraEmail } = useSephoraContext();
  const isLoading = useSelector(selectIsLoadingLoyalty);
  const dispatch = useDispatch();

  const handleContinueClick = () => {
    if (!isValidEmailAddress(sephoraEmail)) {
      setError('Please enter e-mail address in the format username@domain.com');
      return;
    }

    dispatch(linkSephoraAccount(sephoraEmail));
  };

  return isLoading ? (
    <SmallLoader />
  ) : (
    <>
      <div className={cn(css.formField, { [css.fieldError]: error })}>
        <label htmlFor="sephoraEmail">Email Address</label>
        <input
          autoComplete="off"
          type="email"
          name="sephoraEmail"
          value={sephoraEmail}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setSephoraEmail(e.target.value)}
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
          data-test-id={testId('sephoraEmailInput')}
        />
        {error && <div className={css.errorText}>{error}</div>}
      </div>
      <button
        className={css.button}
        type="button"
        disabled={!sephoraEmail}
        onClick={handleContinueClick}
        data-test-id={testId('continueBeautyInsiderButton')}
      >
        Continue
      </button>
      <div className={css.acknowledgment}>
        By clicking on Continue, you acknowledge and agree that Zappos.com LLC may send your relevant purchase information and the email address you
        provided to Sephora.
      </div>
    </>
  );
};

export default BeautyInsiderEmailForm;
